import { render, staticRenderFns } from "./Table-legal-entity.vue?vue&type=template&id=7f0f6588&scoped=true"
import script from "./Table-legal-entity.vue?vue&type=script&lang=js"
export * from "./Table-legal-entity.vue?vue&type=script&lang=js"
import style0 from "./Table-legal-entity.vue?vue&type=style&index=0&id=7f0f6588&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0f6588",
  null
  
)

export default component.exports